<h3 mat-dialog-title>{{ title }}</h3>

<div mat-dialog-content>
    @if (!isfileLoading && uploadedStoredFile == null) {
        <div
            class="uploadFileContainer"
            [ngClass]="{ uploadHover: isHoveringUploader }"
            ng2FileDrop
            (fileOver)="fileOverUploader($event)"
            [uploader]="fileUploadService.uploader"
            (click)="mediaUploader.click()"
            (onFileDrop)="fileAdded()"
        >
            <mat-icon> file_upload </mat-icon>
            <span class="uploaderText">Importez ou déposez votre image ici</span>
        </div>

        <input
            type="file"
            name="mediaUploaderInput"
            id="mediaUploaderInput"
            style="display: none"
            ng2FileSelect
            [uploader]="fileUploadService.uploader"
            [multiple]="false"
            [accept]="fileExtensionAccepted"
            (onFileSelected)="fileAdded()"
            #mediaUploader
        />
    } @else if (isfileLoading) {
        <div>
            <mat-spinner style="margin: 0 auto 5px auto" [diameter]="50"></mat-spinner>
            <p style="text-align: center"><i>Chargement de votre fichier ...</i></p>
        </div>
    } @else {
        <div>
            <button class="removeImgBtn" mat-icon-button (click)="uploadedStoredFile = null">
                <mat-icon>close</mat-icon>
            </button>
            <img class="imgPreview" [src]="getSrc(uploadedStoredFile)" [alt]="uploadedStoredFile.fileName" />
        </div>
    }
</div>

<div mat-dialog-actions style="justify-content: flex-end">
    <button mat-stroked-button color="secondary" tabindex="-1" [mat-dialog-close]="null">Annuler</button>
    <button
        [disabled]="uploadedStoredFile === null || isfileLoading"
        mat-raised-button
        color="primary"
        (click)="validUpload()"
    >
        Valider
    </button>
</div>
